import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Box } from '@mui/material';
import { useAuth } from './context/AuthContext';
import Layout from './components/Layout/Layout';
import LoadingSpinner from './components/common/LoadingSpinner';
import LoginPage from './pages/LoginPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import ProfilePage from './pages/ProfilePage';
import CreateLeadPage from './pages/CreateLeadPage';
import MyLeadsPage from './pages/MyLeadsPage';
import FollowupApprovalsPage from './pages/FollowupApprovalsPage';

// Main application component: routing + layout for the Taliaz HMO portal.
function App() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <LoadingSpinner />
      </Box>
    );
  }

  return (
    <Routes>
      {!user ? (
        <>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </>
      ) : (
        <>
          <Route path="/" element={<Navigate to="/create-lead" replace />} />
                    <Route path="/create-lead" element={<Layout><CreateLeadPage /></Layout>} />
          <Route path="/my-leads" element={<Layout><MyLeadsPage /></Layout>} />
          <Route path="/followup-approvals" element={<Layout><FollowupApprovalsPage /></Layout>} />
          <Route path="/profile" element={<Layout><ProfilePage /></Layout>} />
          <Route path="*" element={<Navigate to="/create-lead" replace />} />
        </>
      )}
    </Routes>
  );
}

export default App;
